import { NextPageContext } from 'next';

import styles from './error.module.scss';

interface ErrorComponentProps {
	statusCode?: number;
}

const getText = (status?: number) => {
	switch (status) {
		case 400:
			return {
				title: 'Error 400',
				subtext: 'There was an error with your request.',
			};
		case 401:
			return {
				title: 'Error 401',
				subtext: 'Your request could not be processed. Try again.',
			};
		case 403:
			return {
				title: 'Error 403',
				subtext: 'Your request has been refused by the server.',
			};
		case 404:
			return {
				title: 'Error 404',
				subtext: 'The requested action could not be found.',
			};
		case 408:
			return {
				title: 'Error 408',
				subtext: 'The server timed out waiting for the request. Try attempting the action again.',
			};
		case 410:
			return {
				title: 'Error 410',
				subtext: 'The requested resource is no longer available and won’t be available again.',
			};
		case 429:
			return {
				title: 'Error 429',
				subtext: 'We received too many requests. Please try again later.',
			};
		case 500:
			return {
				title: 'Internal server error',
				subtext: 'The server encountered an error and was unable to complete your request',
			};
		case 501:
			return {
				title: 'Error 501',
				subtext:
					'The server did not recognise this request as it does not exist or cannot be found.',
			};
		case 502:
			return {
				title: 'Error 502',
				subtext:
					'The page you requested could not be processed. Try refreshing the page or go back and attempt the action again. ',
			};
		case 503:
			return {
				title: 'Error 503',
				subtext:
					'The server is temporarily unavailable. We are looking into this and will be up and running very soon. Thanks for your patience.',
			};
		case 504:
			return {
				title: 'Error 504',
				subtext: 'The page took too long to respond. Try refreshing the page again.',
			};
		case 505:
			return {
				title: 'Error 505',
				subtext: 'The server is unable to support this request.',
			};
		case 511:
			return {
				title: 'Error 511',
				subtext: 'You will need to authenticate to gain access to the network.',
			};
		default:
			return {
				title: 'Unknown error',
				subtext: 'An unknown error has occurred, Try refreshing the page or try again later.',
			};
	}
};
function ErrorComponent({ statusCode }: ErrorComponentProps): React.ReactElement {
	return (
		<div className={styles.error}>
			<div className={styles['error-icon']}>
				<div className={styles['error-icon-header']}>
					<div className={styles['error-icon-circle']} />
					<div className={styles['error-icon-circle']} />
					<div className={styles['error-icon-circle']} />
					<div className={styles['error-icon-triangle']}>
						<p className={styles['error-icon-triangle-text']}>!</p>
					</div>
				</div>
				<div className={styles['error-icon-text']}>
					<p>{statusCode || '???'}</p>
				</div>
			</div>
			<p className={styles['error-title']}>{getText(statusCode).title}</p>
			<p className={styles['error-subtext']}>{getText(statusCode).subtext}</p>
		</div>
	);
}

ErrorComponent.getInitialProps = ({ res, err }: NextPageContext) => {
	const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
	return { statusCode };
};

export default ErrorComponent;
